<template>
  <div>
    <!-- 采购 -->
    <el-card shadow="never">
      <div slot="header"><span>采购单</span></div>
      <div class="text item" style="padding:5px 0 25px 0">
        <el-col :span="24">
          <el-col :span="6">
            <el-switch style="display:block;" v-model="settinglists.isverify" active-color="#13ce66"
              inactive-color="#cccccc" inactive-text="采购单开启审核" @change="changesetting('isverify')"></el-switch>
          </el-col>
          <el-col :span="18">
            <el-tag type="danger" size="small">注：该开关打开后，新增采购单需要审核后才能生成进货入库单</el-tag>
          </el-col>
        </el-col>
      </div>
      <div class="text item" style="padding:25px 0 25px 0">
        <el-col :span="24">
          <el-col :span="6">
            <el-switch style="display:block;" v-model="settinglists.isverifystorage" active-color="#13ce66"
              inactive-color="#cccccc" inactive-text="按采购单生成进货入库单"
              @change="changesetting('isverifystorage')"></el-switch>
          </el-col>
          <el-col :span="18">
            <el-tag type="danger" size="small">注：该开关打开后，进货入库新增入库单功能将关闭，新增进货入库的订单将直接从采购单中生成</el-tag>
          </el-col>
        </el-col>
      </div>
    </el-card>

    <!-- 销售出库 -->
    <el-card shadow="never" style="margin-top:10px">
      <div slot="header"><span>销售出库单</span></div>
      <div class="text item" style="padding:5px 0 25px 0">
        <el-col :span="24">
          <el-col :span="6">
            <el-switch style="display:block;" v-model="settinglists.isopenpay" active-color="#13ce66"
              inactive-color="#cccccc" inactive-text="销售出库单是否限制选择付款方式" @change="changesetting('isopenpay')"></el-switch>
          </el-col>
          <el-col :span="18">
            <el-tag type="danger" size="small">注：该开关打开后，销售出库的订单里的支付方式只能选择未付款、预存款支付</el-tag>
          </el-col>
        </el-col>
      </div>
    </el-card>

    <!-- 快递鸟配置 -->
    <el-card shadow="never" style="margin-top:10px">
      <div slot="header"><span>快递鸟配置</span></div>
      <div class="text item">
        <el-tag type="danger" size="small">注：使用电子面单功能时，需配置快递鸟以下参数;快递鸟的申请地址：https://www.kdniao.com/</el-tag>
        <div v-if="!isEditing" style="display: flex; flex-direction: column;width: 540px;margin-top: 20px;">
          <el-tag type="info" style="margin-bottom: 10px">用户ID: ******</el-tag>
          <el-tag type="info" style="margin-bottom: 10px">秘钥: ******</el-tag>
        </div>
        <el-form v-if="isEditing" :model="kdniaoConfig" :rules="kdniaoRules" size="mini" ref="kdniaoForm"
          label-width="100px" style="width: 540px;margin-top: 20px;">
          <el-form-item label="用户ID:" prop="kdniao_app_id">
            <el-input v-model="kdniaoConfig.kdniao_app_id" placeholder="请输入用户ID"></el-input>
          </el-form-item>
          <el-form-item label="秘钥:" prop="kdniao_secret_key">
            <el-input v-model="kdniaoConfig.kdniao_secret_key" placeholder="请输入秘钥"></el-input>
          </el-form-item>
        </el-form>
        <div style="display: flex;justify-content: flex-end;width: 540px;">
          <el-button v-if="!isEditing" type="primary" @click="toggleEdit" size="mini">修改</el-button>
          <el-button v-if="isEditing" type="primary" @click="submitKdniaoConfig" size="mini">保存</el-button>
          <el-button v-if="isEditing" type="default" @click="cancelEdit" size="mini">取消</el-button>
        </div>
      </div>
    </el-card>
    <!-- 货位功能 -->
    <el-card v-if="version != 13" shadow="never" style="margin-top:10px">
      <div slot="header"><span>货位功能</span></div>
      <div class="text item" style="padding:5px 0 25px 0">
        <el-col :span="24">
          <el-col :span="6">
            <el-switch style="display:block;" :disabled="settinglists.storage_location"
              v-model="settinglists.storage_location" active-color="#13ce66" inactive-color="#cccccc"
              inactive-text="开启货位功能" @change="changesetting('storage_location')"></el-switch>
          </el-col>
          <el-col :span="18">
            <el-tag type="danger" size="small">注：该开关打开后，只能通过技术人员关闭</el-tag>
          </el-col>
        </el-col>
      </div>
    </el-card>

    <!-- 批次功能 -->
    <el-card shadow="never" style="margin-top:10px">
      <div slot="header"><span>开启商品批次管理功能</span></div>
      <div class="text item" style="padding:5px 0 25px 0">
        <el-col :span="24">
          <el-col :span="6">
            <el-switch style="display:block;" v-model="settinglists.batch_school_period" active-color="#13ce66"
              inactive-color="#cccccc" inactive-text="启用批次/有效期管理"
              @change="changesetting('batch_school_period')"></el-switch>
          </el-col>
          <el-col :span="18">
            <el-tag type="danger" size="small">注:若您需要对商品进行批次或保质期管理，请勾选</el-tag>
          </el-col>
        </el-col>
      </div>
    </el-card>

    <!-- 发票邮箱配置 -->
    <el-card shadow="never" style="margin-top:10px">
      <div slot="header"><span>发送邮箱配置</span></div>
      <div class="text item" style="padding:5px 0 25px 0">

        <div><el-tag type="danger" size="small">注:发送邮箱配置由于后台开票后，将发票信息发送给填写的收票邮箱;</el-tag></div>
        <el-form ref="smtpForm" :model="form" :rules="rules" label-width="150px" style="width: 800px;margin-top: 20px;">

          <!-- SMTP服务器地址 -->
          <el-form-item label="SMTP服务器地址" prop="smtp_url">
            <el-input v-model="form.smtp_url" :disabled="modify == false" placeholder="请输入SMTP服务地址" clearable>
              <i slot="prefix" class="el-icon-s-promotion icon"></i>
            </el-input>
          </el-form-item>

          <!-- SMTP端口 -->
          <el-form-item label="SMTP端口" prop="smtp_port">
            <el-input v-model="form.smtp_port" :disabled="modify == false" type="number" placeholder="请输入SMTP端口" clearable>
              <i slot="prefix" class="el-icon-cpu icon"></i>
            </el-input>
          </el-form-item>

          <!-- 邮箱账户 -->
          <el-form-item label="邮箱账户" prop="email_account">
            <el-input v-model="form.email_account" :disabled="modify == false" autocomplete="off" placeholder="请输入邮箱账户" clearable>
              <i slot="prefix" class="el-icon-user icon"></i>
            </el-input>
          </el-form-item>

          <!-- 授权秘钥 -->
          <el-form-item label="授权秘钥" prop="emali_password">
            <el-input v-model="form.emali_password" :disabled="modify == false" :type="type" @focus="type = 'password'" autocomplete="off" placeholder="请输入授权秘钥"
              show-password clearable>
              <i slot="prefix" class="el-icon-lock icon"></i>
            </el-input>
          </el-form-item>

          <!-- 保存按钮 -->
          <el-form-item>
            <el-button v-if="modify == true" type="primary" size="mini" @click="submitForm('smtpForm')">
              保存配置
            </el-button>
            <el-button v-if="modify == false" type="primary" size="mini" @click="modify = true">
              修改
            </el-button>
            <el-button v-if="modify == true" size="mini" @click="modify = false">
              取消
            </el-button>
          </el-form-item>
        </el-form>
        <div style="display: none;">
          <input type="email" name="fake-email" autocomplete="off">
          <input type="password" name="fake-password" autocomplete="off">
        </div>
      </div>
    </el-card>


  </div>
</template>

<script>
export default {
  data() {
    // 验证邮箱格式的函数
    var validateEmail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入邮箱地址'));
      } else {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (!emailRegex.test(value)) {
          callback(new Error('请输入有效的邮箱地址'));
        } else {
          callback();
        }
      }
    };

    // 验证端口号的函数
    var validatePort = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入端口号'));
      } else {
        const port = Number(value);
        if (isNaN(port)) {
          callback(new Error('端口号必须是数字'));
        } else if (port < 1 || port > 65535) {
          callback(new Error('端口号必须在1-65535之间'));
        } else {
          callback();
        }
      }
    };
    return {
      url: this.GLOBAL.domain + "Setting/index",
      type: 'text',
      modify: false,
      settinglists: [],
      isEditing: false,
      kdniaoConfig: {
        kdniao_app_id: '',
        kdniao_secret_key: ''
      },
      kdniaoRules: {
        kdniao_app_id: [
          { required: true, message: '请输入用户ID', trigger: 'blur' }
        ],
        kdniao_secret_key: [
          { required: true, message: '请输入秘钥', trigger: 'blur' }
        ]
      },
      version: '',
      form: {
        token: this.$cookies.get('token'),
        act: 'send_email_setting',
        smtp_url: '',
        smtp_port: '',
        email_account: '',
        emali_password: ''
      },
      email: '',
      pws: '',
      rules: {
        smtp_url: [
          { required: true, message: '请输入SMTP服务器地址', trigger: 'blur' },
          { min: 5, message: '服务器地址长度不能少于5个字符', trigger: 'blur' }
        ],
        smtp_port: [
          { required: true, message: '请输入SMTP端口号', trigger: 'blur' },
          { validator: validatePort, trigger: 'blur' }
        ],
        email_account: [
          { required: true, message: '请输入邮箱账户', trigger: 'blur' },
          { validator: validateEmail, trigger: 'blur' }
        ],
        emali_password: [
          { required: true, message: '请输入邮箱密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6个字符', trigger: 'blur' }
        ]
      }
    }
  },

  mounted() {
    this.getSettinglists();
    const verson = localStorage.getItem('version_id');
    this.version = verson;
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var resource = this.$resource(this.url);
          resource.query(this.form).then((res) => {
            if (res.data.Result > 0) {
              if (res.data.Result == '70001') this.$router.push('/login');
              this.$message.error(res.data.Message);
            } else {
              // this.settinglists = JSON.parse(Base64.decode(res.data.Data));
              this.$message.success('保存成功!');
            }
          }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
          });

        }
      });
    },
    //重置表单
    reset() {
      this.$refs.update.resetFields();
    },

    //获取设置信息列表
    getSettinglists() {
      var resource = this.$resource(this.url);
      resource.query({ act: 'settinglists', token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login');
          this.$message.error(res.data.Message);
        } else {
          this.settinglists = JSON.parse(Base64.decode(res.data.Data));
          console.log(this.settinglists, 'KKKKKKKKKKKKK');
          if (this.settinglists.smtp) {

            this.form.email_account = this.settinglists.smtp.email_account || '';
            this.form.emali_password = this.settinglists.smtp.emali_password || '';
            this.type = 'password'
            this.form.smtp_port = this.settinglists.smtp.smtp_port || '';
            this.form.smtp_url = this.settinglists.smtp.smtp_url || '';
          }
          if (this.form.email_account) {
            this.modify = false
          }
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },

    // 开启/关闭开关
    changesetting(type) {
      var resource = this.$resource(this.url);
      var obj = {}

      if (type == 'batch_school_period') {
        obj = { act: 'validity_period_setting', token: this.$cookies.get('token'), batch_school_period: this.settinglists[type] }
      } else {
        obj = { act: 'changesetting', token: this.$cookies.get('token'), type: type, value: this.settinglists[type] }
      }

      if (this.settinglists[type]) {
        localStorage.setItem('storageLocationStatus', this.settinglists.storage_location);
      }
      resource.query(obj).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login');
          this.$message.error(res.data.Message);
        } else {
          this.$message.success('设置成功!');
          // 刷新系统页面
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },

    // 切换编辑状态
    toggleEdit() {
      this.isEditing = true;
    },

    // 提交快递鸟配置
    submitKdniaoConfig() {
      this.$refs.kdniaoForm.validate((valid) => {
        if (valid) {
          // 这里可以添加保存配置的逻辑
          var resource = this.$resource(this.url);
          resource.query({
            act: 'kdniaosetting',
            token: this.$cookies.get('token'),
            kdniao_app_id: this.kdniaoConfig.kdniao_app_id,
            kdniao_secret_key: this.kdniaoConfig.kdniao_secret_key
          }).then((res) => {
            if (res.data.Result > 0) {
              if (res.data.Result == '70001') this.$router.push('/login');
              this.$message.error(res.data.Message);
            } else {
              this.isEditing = false;
              this.$message.success('保存成功!');
              // 刷新设置信息列表
            }
          }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
          });
        } else {
          console.log('表单验证失败');
          return false;
        }
      });
    },

    // 取消编辑
    cancelEdit() {
      this.isEditing = false;
      this.reset();
    }
  }
}
</script>
<style>
.el-switch__label.is-active {
  color: #303133
}
</style>


// WEBPACK FOOTER //
// src/components/config/Setting.vue